import { FC } from 'react';
import { AlertCircle } from 'lucide-react';

interface EligibilityWarningProps {
  isPremium: boolean;
  activityMonths: number;
}

export const EligibilityWarning: FC<EligibilityWarningProps> = ({ isPremium, activityMonths }) => {
  if (isPremium && activityMonths >= 3) return null;

  return (
    <div className="mt-4 p-4 bg-yellow-50 rounded-lg flex items-start gap-2">
      <AlertCircle className="h-5 w-5 text-yellow-500 shrink-0 mt-0.5" />
      <div className="space-y-1">
        <p className="text-sm text-yellow-700">
          Aún no cumples con todos los requisitos para ser socio.
        </p>
        <ul className="text-xs text-yellow-600 list-disc list-inside">
          {!isPremium && (
            <li>Necesitas una suscripción premium activa</li>
          )}
          {activityMonths < 3 && (
            <li>Te faltan {3 - activityMonths} meses de actividad consecutiva</li>
          )}
        </ul>
      </div>
    </div>
  );
};